/** Fixed texts per status, so the chat never shows a server message to the user. */
const MESSAGES: Record<number, string> = {
  404: 'The goods item or its conversation was not found.',
  422: 'The answer was blocked by a safety check. Try rephrasing the question.',
  503: 'The AI chat is not enabled.',
};

const GENERIC = 'The AI chat is temporarily unavailable. Please try again later.';

export class ItemAiChatError extends Error {
  constructor(public readonly status: number) {
    super(MESSAGES[status] ?? GENERIC);
    this.name = 'ItemAiChatError';
  }
}

export const itemAiChatErrorMessage = (error: unknown): string => (error instanceof ItemAiChatError ? error.message : GENERIC);
